export var da_DK = {
  "search": "Søg",
  "matches": "matcher",
  "close": "Luk",
  "doDetails": "Se detaljer",
  "at_site": "på"
};
export var sv_SE = {
  "search": "Sök",
  "matches": "matchar",
  "close": "Stäng",
  "doDetails": "Detaljer",
  "at_site": "på"
};
export var en_GB = {
  "search": "Search",
  "matches": "match",
  "close": "Close",
  "doDetails": "Details",
  "at_site": "at"
};
var runtimeLocales = {
  da_DK: da_DK,
  sv_SE: sv_SE,
  en_GB: en_GB
};
export var defaultLocale = 'da_DK';
var currentLocale = da_DK;
export function setLocaleByIdentifier(localeIdentifier) {
  if (runtimeLocales[localeIdentifier]) currentLocale = runtimeLocales[localeIdentifier];
}
export function setLocale(locale) {
  currentLocale = locale;
}
export function getString(name) {
  return currentLocale[name] || name;
}